/**
 * Defines a breadcrumbs nav
 *
 * <gw-breadcrumbs>
 *   <gw-breadcrumbs-item>Account: Ray Newton</gw-breadcrumbs-item>
 *   <gw-breadcrumbs-item>Policy: Personal Auto 0726849902</gw-breadcrumbs-item>
 * </gw-breadcrumbs>
 */
define(
    ['text!./templates/Breadcrumbs.html', './LayoutFactory'],
    (template, layout) => layout('Breadcrumbs', template, partial => {
        partial('Item');
    })
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/layouts/Breadcrumbs.js